import { Component, OnInit } from '@angular/core';
import { throwMatDialogContentAlreadyAttachedError } from '@angular/material/dialog';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { UserService } from 'src/app/core/services/user.service';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-notification-switch',
  templateUrl: './notification-switch.component.html',
  styleUrls: ['./notification-switch.component.scss']
})
export class NotificationSwitchComponent implements OnInit {
  private sw: ServiceWorkerRegistration;
  subscribed = false;
  unsupported = false;
  showError = false;

  constructor(private userService: UserService) { }

  ngOnInit(): void {
    if ('serviceWorker' in navigator && 'PushManager' in window) {
      //Find service worker
      navigator.serviceWorker.getRegistrations()
        .then(regs => {
          this.sw = regs.find(x => x.active);

          if (!!this.sw) {
            //Check if user has subscription
            this.sw.pushManager.getSubscription().then(sub => {              
              this.subscribed = !(sub === null);

              if (this.subscribed && Notification.permission === 'denied') {
                //User has denied notifications, update user
                this.removeSubscription(sub.endpoint);
                this.subscribed = false;
              }
            })
          }
        });
    }
    else {
      this.unsupported = true;
    }
  }

  activationChange(event: MatSlideToggleChange) {
    event.source.disabled = true;

    if (this.canActivate()) {
      this.showError = false;

      if (this.subscribed) {
        //Unsubscribe
        let subscription: PushSubscription = null;
        this.sw.pushManager.getSubscription().then(sub => {
          if (sub) {
            subscription = sub;
            return sub.unsubscribe();
          }
        })
        .then(success => {
          if (success) {
            this.removeSubscription(subscription.endpoint);
            this.subscribed = false;
          }
          else {
            throw { message: "Endpoint failed" };
          }
        })
        .catch(err => {
          console.log("Failed to unsubscribe", err);
          this.subscribed = true;
        })
        .finally(() => {
          event.source.disabled = false;
        });        
      }
      else {
        //Subscribe
        const applicationServerKey = this.urlB64ToUint8Array(environment.notifications.applicationServerPublicKey);
        this.sw.pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey: applicationServerKey
        })
        .then(sub => {
          this.createSubscription(sub);
          this.subscribed = true;
        })
        .catch(err => {
          this.subscribed = false;
          event.source.checked = false;
        })
        .finally(() => {
          event.source.disabled = false;
        });        
      }
    }
    else {      
      event.source.checked = false;
      this.showError = true;
    }
  }  

  canActivate() {
    return !this.unsupported && Notification.permission !== 'denied';
  }

  private removeSubscription(endpoint: string) {
    this.userService.unsubscribePushNotifications(endpoint).subscribe();
  }

  private createSubscription(sub: PushSubscription) {
      this.userService.subscribePushNotifications(
        sub.endpoint, 
        this.arrayBufferToBase64(sub.getKey('p256dh')), 
        this.arrayBufferToBase64(sub.getKey('auth'))).subscribe();
  }

  private urlB64ToUint8Array(base64String: string) {
    const padding = '='.repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding)
      .replace(/\-/g, '+')
      .replace(/_/g, '/');
  
    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);
  
    for (let i = 0; i < rawData.length; ++i) {
      outputArray[i] = rawData.charCodeAt(i);
    }

    return outputArray;
  }  

  private arrayBufferToBase64(buffer: ArrayBuffer) {
    var binary = '';
    var bytes = new Uint8Array(buffer);
    var len = bytes.byteLength;
    for (var i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
  }

}
